/**
 * Created by Ramon Wenger on 04.07.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */

import {ChangeDetectionStrategy, Component, OnInit} from "@angular/core";

import {Store} from "@ngrx/store";

import * as reducer from "../reducers";
import {Observable} from "rxjs";
import {AdminMessage} from "./admin-message";
import {LoadAdminMessagesAction, MarkAdminMessageReadAction} from "../actions/klassenbuch";


@Component({
  selector: 'hc-admin-messages',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="admin-messages">
      <hc-admin-message [adminMessage]="message" [language]="language$ | async" (hasRead)="hasRead($event)"
                        *ngFor="let message of messages$ | async"></hc-admin-message>
      <!--      <hc-admin-message [adminMessage]="(messages$ | async)?.[0]"-->
      <!--                        [language]="language$ | async"-->
      <!--                        (hasRead)="hasRead($event)">-->
      <!--      </hc-admin-message>-->
    </div>

  `
})
export class AdminMessagesComponent implements OnInit {
  messages$: Observable<AdminMessage[]>;
  language$: Observable<string>;

  constructor(private store: Store<reducer.AppState>) {
    this.messages$ = store.select(reducer.getAdminMessages);
    this.language$ = store.select(reducer.getLanguage);
  }

  ngOnInit() {
    this.store.dispatch(new LoadAdminMessagesAction());
  }

  hasRead(id: number) {
    this.store.dispatch(new MarkAdminMessageReadAction(id));
  }
}
